const REMOVE_FROM_FOLDER_OPTION = "Remove From Current Folder"

export { REMOVE_FROM_FOLDER_OPTION }
